import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { BaseUnit } from '../../theming/baseUnitDefinition';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { useHeaderHeights } from '../components/navigation/header/headerWithSubMenus/useHeaderHeights';

const componentConfigThemeKey = 'main';

interface MainWrapperThemeProps {
    baseUnit: BaseUnit;
    backgroundColor: string;
}

interface MainWrapperForHeaderWithSubMenusProps {
    configThemeKey?: string;
}

export const MainWrapperForHeaderWithSubMenus: React.FunctionComponent<MainWrapperForHeaderWithSubMenusProps> = ({ children, configThemeKey }) => {
  const { baseUnit, backgroundColor } = useTheme<MainWrapperThemeProps>(configThemeKey || componentConfigThemeKey);
  const headerHeights = useHeaderHeights();

  const style = {
    backgroundColor,
    paddingBottom: `${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      paddingTop: `${headerHeights.large * baseUnit + baseUnit / 4}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingTop: `${headerHeights.medium * baseUnit + baseUnit / 4}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingTop: `${headerHeights.small * baseUnit + baseUnit / 4}px`,
    },
  };

  return (
    <main
      className={css(StyleSheet.create({ style }).style)}
    >
      {children}
    </main>
  );
};
